import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import makeRequest from "../../../../api";
import { adminService, trainerService } from "../../../../api/services";
import { toast } from "react-toastify";

const EditTrainer = () => {
  const params = useParams();
  const trainerId = params.trainerId;

  const [trainerData, setTrainerData] = useState<any>({});
  const [rolesList, setRolesList] = useState<any>([]);
  const [inputData, setInputData] = useState<{ roles: any[] }>({
    roles: [],
  });

  const fetchRoles = async () => {
    try {
      const res = await makeRequest(trainerService.getTrainerRoleList());
      const resData = res?.data?.body?.roles;
      const data = resData?.map((item: any) => ({
        label: item?.roleName,
        value: item?.roleId,
      }));
      setRolesList([...data]);
    } catch (error: any) {
      toast.error("Error fetching trainer's role!");
    }
  };

  const fetchDetails = async () => {
    try {
      const res = await makeRequest(
        trainerService.getTrainerData({ trainerId }, trainerId)
      );
      setTrainerData({ ...res?.data?.trainer });
      const resData = res?.data?.trainer?.roles;
      const data = resData?.map((item: any) => ({
        label: item?.roleName,
        value: item?.roleId,
      }));
      setInputData({
        roles: [...data],
      });
    } catch (error: any) {
      toast.error("Error fetching trainer's data!");
    }
  };

  useEffect(() => {
    fetchDetails();
    fetchRoles();
  }, []);

  const updateTrainerRoles = async () => {
    try {
      const data = {
        trainerId: trainerData?.trainerId,
        category: trainerData?.category,
        roles: inputData?.roles?.map((item: any) => ({ roleId: item.value })),
      };

      const res = await makeRequest(
        adminService.updateTrainerRoles(data, trainerData?.trainerId)
      );
      toast.success("Roles updated successfully!");
      fetchDetails();
    } catch (err) {
      toast.error("Something went wrong!");
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    updateTrainerRoles();
  };

  const handleSelectChange = (data: any, name: any) => {
    setInputData({ ...inputData, [name]: data });
  };

  return (
    <div className="container-lg">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/admin/trainers">Trainer</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              View or edit
            </li>
          </ol>
        </nav>
      </div>
      <div className="card w-50 p-3 mb-4">
        <div className="card-detail d-flex flex-column">
          <strong>Name: {trainerData.name}</strong>
          <strong>Category: {trainerData.category}</strong>
        </div>
      </div>
      <div className="w-50">
        <form onSubmit={handleSubmit}>
          <div className="form-goup mb-4">
            <label className="mb-2" htmlFor="value">
              <strong>Roles</strong>
            </label>
            <Select
              isMulti={true}
              value={inputData?.roles}
              onChange={(option: any) => {
                handleSelectChange(option, "roles");
              }}
              name="no_nonveg_days"
              options={rolesList}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
          <button className="btn btn-sm btn-outline-success">
            Update trainer roles
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditTrainer;
